// Адреса публичных страниц позиций: /product/<id>-<слова>/, /bouquet/…, /catalog/… (с 27.10.2026;
// старые /tovar/ /buket/ /katalog/ сервер переадресует, а витрина по-прежнему узнаёт).
// Зеркало backend/app/seo_urls.py — правила обязаны совпадать (иначе ссылка из
// витрины будет уводить через лишний 301). Тестовые пары — в
// src/__tests__/productUrl.test.js и backend/scripts/tests/test_product_pages.py.

// Та же таблица, что у авто-slug категорий (backend/app/routers/categories.py).
const TRANSLIT = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z',
  и: 'i', й: 'i', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r',
  с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch',
  ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

export const SLUG_MAX_LEN = 60;

const PREFIX = { product: 'product', bouquet: 'bouquet', category: 'catalog' };
const KIND_BY_PREFIX = {
  product: 'product', bouquet: 'bouquet', catalog: 'category',
  tovar: 'product', buket: 'bouquet', katalog: 'category',   // до 27.10
};

export function slugify(text) {
  let s = Array.from(String(text || '').toLowerCase())
    .map(ch => (ch in TRANSLIT ? TRANSLIT[ch] : ch))
    .join('')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  if (s.length > SLUG_MAX_LEN) {
    let cut = s.slice(0, SLUG_MAX_LEN);
    if (s[SLUG_MAX_LEN] !== '-' && cut.includes('-')) cut = cut.slice(0, cut.lastIndexOf('-'));
    s = cut.replace(/^-+|-+$/g, '');
  }
  return s;
}

export function itemPath(kind, id, name) {
  const slug = slugify(name);
  return `/${PREFIX[kind]}/${slug ? `${id}-${slug}` : id}/`;
}

// «/product/12-roza-60-sm/» (и старое «/tovar/…») → { kind: 'product', id: 12 }; не наш путь → null
export function parseItemPath(pathname) {
  const m = /^\/(product|bouquet|catalog|tovar|buket|katalog)\/(\d{1,9})(?:-[a-z0-9-]*)?\/?$/.exec(pathname || '');
  if (!m) return null;
  return { kind: KIND_BY_PREFIX[m[1]], id: Number(m[2]) };
}

// start_param из бота: p_12 — товар, b_45 — букет, c_3 — категория
export function parseStartParam(param) {
  const m = /^([pbc])_(\d{1,9})$/.exec(param || '');
  if (!m) return null;
  return { kind: { p: 'product', b: 'bouquet', c: 'category' }[m[1]], id: Number(m[2]) };
}

// Подборка по цветку: «/podborka/kally/» → { kind: 'collection', id: 'kally' }. Страницу для поиска
// отдаёт сервер, состав — GET /api/seo/collections/<slug> (ТЗ «реклама по наличию», 29.10.2026)
export function parseCollectionPath(pathname) {
  const m = /^\/podborka\/([a-z0-9][a-z0-9-]{0,63})\/?$/.exec(pathname || '');
  return m ? { kind: 'collection', id: m[1] } : null;
}

// Метка сервера после переадресации с архивной позиции в её раздел: «?gone=p12» / «?gone=b45»
// (backend/app/routers/seo_pages.py, _archived_redirect) → { kind: 'product', id: 12, gone: true }
export function parseGoneParam(search) {
  let value = null;
  try { value = new URLSearchParams(search || '').get('gone'); } catch (e) { return null; }
  const m = /^([pb])(\d{1,9})$/.exec(value || '');
  if (!m) return null;
  return { kind: m[1] === 'p' ? 'product' : 'bouquet', id: Number(m[2]), gone: true };
}
